import Vue from 'vue';
import './plugins/mixins';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;

window.$Vm = new Vue({
  router,
  vuetify,
  render: (h) => h(App),
});

window.$Vm.$mount('#app');
